// ─────────────────────────────────────────────────────────────
// BEFORE / AFTER TRANSFORMATIONS
// ─────────────────────────────────────────────────────────────
// BEFORE = plain / average kitchen photo (placeholder)
// AFTER  = the finished Mirabilis kitchen (real photos where
//          possible)
//
// Every BEFORE image below has been visually verified as a
// full-view, dated (7-9/10) kitchen with cabinets, appliances
// and counters — NOT a rustic prop shot. Stock libraries cannot
// provide angle-matched before/after pairs; for perfect matches
// replace with your own on-site job photos.
// ─────────────────────────────────────────────────────────────

const CDN =
  "https://storage.googleapis.com/msgsndr/XFavMTRXOcB6zlC9P1WM/media";

export const TRANSFORMATIONS = [
  {
    id: "transformation-1-mosman-headland",
    title: "Mosman Headland",
    suburb: "Mosman, NSW",
    audience: "Homeowner",
    // PLACEHOLDER · BEFORE — average, worn family kitchen: cherry
    // wood arched cabinets, laminate countertops, small island,
    // stainless appliances. Reads as an ~15-20 year old suburban
    // kitchen. 6-7/10 dated — clearly basic, not extreme.
    before:
      "https://images.pexels.com/photos/24245780/pexels-photo-24245780.jpeg?auto=compress&cs=tinysrgb&w=1800",
    // KEEP · AFTER — real finished Mirabilis kitchen (Mosman Headland)
    after: `${CDN}/690dbf1925530f69bbfa45d2.jpeg`,
  },
  {
    id: "transformation-2-albert-park-terrace",
    title: "Albert Park Terrace",
    suburb: "Hawthorn, VIC",
    audience: "Homeowner",
    // PLACEHOLDER · BEFORE — plain older kitchen
    before:
      "https://images.unsplash.com/photo-1484154218962-a197022b5858?auto=format&fit=crop&w=1800&q=80",
    // PLACEHOLDER · AFTER — a nicely finished heritage kitchen
    after:
      "https://images.unsplash.com/photo-1683629357963-adf2b1fa9ad9?auto=format&fit=crop&w=1800&q=80",
  },
  {
    id: "transformation-3-parramatta-rise",
    title: "Parramatta Rise",
    suburb: "Parramatta, NSW",
    audience: "Builder",
    // PLACEHOLDER · BEFORE — average, worn apartment kitchen:
    // medium wood cabinets, laminate countertop, black appliances,
    // hardwood floor. Reads as an untouched-in-20-years rental. 6-7/10
    // dated — clearly basic, not extreme.
    before:
      "https://images.pexels.com/photos/6835155/pexels-photo-6835155.jpeg?auto=compress&cs=tinysrgb&w=1800",
    // PLACEHOLDER · AFTER — modern L-shape marble kitchen
    after:
      "https://images.pexels.com/photos/35189709/pexels-photo-35189709.jpeg?auto=compress&cs=tinysrgb&w=1800",
  },
];
